var app = angular.module('leonardo');

var CurrencyCodeFormat = function ($filter) {
  return {
    restrict: 'A',
    require: ['ngModel'],
    link: function (scope, element, attrs, ctrls) {
      scope.ngModelCtrl = ctrls[0];

      scope.regex = /[+-]?\d+(,\d+)*(\.\d+)?/g;

      scope.currencyCode = !isNull(attrs.symbol) ? attrs.symbol : 'USD';
      scope.fractionSize = !isNull(attrs.fractionSize) ? parseInt(attrs.fractionSize) : 6;

      scope.setValue = function (value) {
        if (!isNull(value)) {
          var value_num = value.replace(" " + scope.currencyCode, "");
          if (!isNull(value_num) && (value_num[0] === '.')) {
            value_num = '0' + value_num;  
          }
          var match = value_num.match(scope.regex);
          if (!isNull(match)) {
            match.map(function (v) {
              const val = parseFloat(v.replace(/[,]/g, '')).toString();
              let decimalsArray = val.split('.');
              let decimals = decimalsArray.length > 1 ? decimalsArray[1].length : 0;
              decimals = decimals <= scope.fractionSize ? decimals : scope.fractionSize;
              decimals = decimals >= 2 ? decimals : 2;
              let currencyNormalFormat = $filter('currency')(val, '', decimals);
              element.val(currencyNormalFormat.split(',').join('') + " " + scope.currencyCode);
              scope.ngModelCtrl.$setViewValue(val);
            });
          }
          else {
            element.val(null);
            scope.ngModelCtrl.$setViewValue(null);
          }
        }
        else {
          element.val(null);
          scope.ngModelCtrl.$setViewValue(null);
        }
      };

      scope.$watch(attrs.ngModel, function (value) {
        scope.value = value;
        scope.setValue(scope.value);
      });

      scope.$watch(attrs.symbol, function (newValue, oldValue) {
        if (!angular.equals(newValue, oldValue)) {
          scope.currencyCode = !isNull(newValue) ? newValue : 'USD';
          scope.setValue(scope.value);
        }
      });

    }
  };
};

app.directive('currencyCodeFormat', ['$filter', CurrencyCodeFormat]);